export default __webpack_public_path__ + "static/media/student.fb0a30fe.svg";